import { useEffect } from "react";
import { useLangNavigate } from "./useLangNavigate";

const Redirect = ({ to }: { to: string }) => {
  const langNavigate = useLangNavigate();

  useEffect(() => {
    langNavigate(to, { replace: true });
  }, [to]);

  return null;
};

export default Redirect;
